<fdr-past-performance-ui-base-card [title]="'PD.PERFORMANCE.INTERVALS' | translate">
  @if (selectedEvent(); as event) {
    <div class="chart-header">
      <span>{{ 'PD.PERFORMANCE.DATETIME' | translate }}:
        <b>{{ event.eventStartDttm | localeDate: 'datetime' : eventTimeZone() : locale : true : false }} - {{ event.eventEndDttm | localeDate: 'time' : eventTimeZone() : locale : true }}</b>
      </span>
      <span
        >{{ 'PD.PERFORMANCE.PROGRAM' | translate }} <b>{{ event.programName || '-' }}</b></span
      >
      @if (showProductRow) {
        <span
          >{{ 'PD.PERFORMANCE.PRODUCT' | translate }} <b>{{ productName() || '-' }}</b></span
        >
      }
      @if (isOrgView()) {
        <span
          >{{ 'PD.PERFORMANCE.ORGANIZATION' | translate }} <b>{{ organizationName() || '-' }}</b></span
        >
        <span
          >{{ 'PD.PERFORMANCE.SITE' | translate }} <b>{{ event.siteName || '-' }}</b></span
        >
      }
      @if (selectedEventDuration()) {
        <span
          >{{ 'PD.PERFORMANCE.EVENT_DURATION' | translate }} <b>{{ selectedEventDuration() }}</b></span
        >
      }
      <span class="warning"><b>{{ 'PD.PERFORMANCE.WARNING' | translate }}</b>: {{ 'PD.PERFORMANCE.WARNING_MESSAGE' | translate }}</span> 
    </div>
  }

  <dsy-toast toast-type="alert" toast-size="standard" has-border="true" noCloseIcon="true" renderLinkSlot="false"></dsy-toast>
  <div *ngIf="bannerDetails()">
    <div
      class="toast-message__container"
      [ngStyle]="{ 'background-color': bannerDetails()?.backgroundColor, border: '2px solid ' + bannerDetails()?.borderColor }"
    >
      <dsy-icon class="banner-icon" [name]="bannerDetails()?.iconName" [color]="bannerDetails()?.borderColor" library="bootstrap"></dsy-icon>
      <div>
        <h2 class="toast-message__title">{{ bannerDetails()?.title }}</h2>
        <p class="toast-message__subtitle">{{ bannerDetails()?.description }}</p>
      </div>
    </div>
  </div> 
 @if (isIntervalLoading()) {
    <div class="chart-state chart-state--loading">
      <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
    </div>
  } @else if (!intervalData()?.length) {
    <div class="chart-state">
      <fdr-past-performance-ui-empty-state icon="search_off"
        title="PD.LABELS.NO_DATA_INTERVAL_AVAILABLE"
        [emphasized]="true"></fdr-past-performance-ui-empty-state>
    </div>
  }
  <fdr-past-performance-ui-chips
    [chipsData]="chipsInfo()"
    (onPress)="disableChip($event)"
    [hidden]="isIntervalLoading() || !intervalData()?.length"
  ></fdr-past-performance-ui-chips>
  <div class="chart-container" [hidden]="isIntervalLoading() || !intervalData()?.length">
    <canvas #chartCanvas></canvas>
  </div>
</fdr-past-performance-ui-base-card>
